// extracted by mini-css-extract-plugin
export var actionButton = "_k2-t";
export var buttonContainer = "_k2-0";
export var buttonContainer2 = "_k2-1";
export var buttonSection = "_k2-2";
export var details = "_k2-3";
export var dropdownItem = "_k2-5";
export var dropdownItemsContainer = "_k2-4";
export var fileInput = "_k2-r";
export var headerButton = "_k2-6";
export var icon = "_k2-7";
export var input = "_k2-8";
export var macroListItem = "_k2-9";
export var mainContent = "_k2-a";
export var microText = "_k2-b";
export var modal = "_k2-w";
export var optionsButton = "_k2-c";
export var paperclip = "_k2-s";
export var pillContent = "_k2-d";
export var preview = "_k2-e";
export var preview2 = "_k2-f";
export var quillEditor = "_k2-q";
export var selectedMacro = "_k2-g";
export var sidebar = "_k2-h";
export var sidebarHeader = "_k2-j";
export var sidebarList = "_k2-i";
export var sidebarListItem = "_k2-k";
export var sidebarSearch = "_k2-l";
export var snoozeDurationWrapper = "_k2-v";
export var statusPillContainer = "_k2-m";
export var tagsContainer = "_k2-n";
export var unselectedMacro = "_k2-o";
export var variable = "_k2-u";
export var wrapper = "_k2-p";